import { APP } from 'src/Configs/App'
import { ArtistRolesEnum } from 'src/Constants/enums'
import { rtkApi } from 'src/Services/rtkApi'

export interface UpdateArtistPhoneNumberRequest {
  phoneNumber: string
}

export interface UpdateArtistRoleRequest {
  artistRole: ArtistRolesEnum
}

const artistProfileApi = rtkApi.injectEndpoints({
  endpoints: (build) => ({
    updateArtistPhoneNumber: build.mutation<
      void,
      UpdateArtistPhoneNumberRequest
    >({
      query: ({ phoneNumber }) => ({
        url: `${APP.TIKTOK_SERVER}/artist/users/current`,
        method: 'PATCH',
        body: { phoneNumber },
      }),
    }),
    updateArtistRole: build.mutation<void, UpdateArtistRoleRequest>({
      query: ({ artistRole }) => ({
        url: `${APP.TIKTOK_SERVER}/artist/users/current`,
        method: 'PATCH',
        body: { artistRole },
      }),
    }),
  }),
})

export const {
  useUpdateArtistPhoneNumberMutation,
  useUpdateArtistRoleMutation,
} = artistProfileApi
